module.exports = __webpack_public_path__ + "static/media/ic-edit-active.e7cd08d4.svg";